const u_OnElementLoad = (selector, callback) => {
  let count = 0
  var t = setInterval(() => {
    var element = document.querySelector(selector);
    count += 100;
    if (
      (element !== null && element !== undefined) || 
      count > 100 * 100 // 10 seconds timeout
    ) {
      clearInterval(t);
      callback(element);
    }
  }, 100);
}  

const u_FormatMoney = (value) => {
  return window.theme.formatMoney(value);
};

const u_AddItemsToCart = async (items_to_add) => {
  // items_to_add = [{
  //   quantity: qty,
  //   id: variant_id,
  //   selling_plan: selling_plan_id,
  //   properties: {}
  // }]
  return await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ items: items_to_add })
  });
}

const mixedCaseShared = {
  maxItems: 2,

  initTapcart(ctx) {
    if (!Shopify.shop) {
      window.addEventListener('webbridge-ready', () => {
        ctx.isTapcart = true;
      });
    }
  },

  initCache(ctx) {
    ctx.cache.$el = ctx.$el;
    ctx.main_product = JSON.parse(ctx.cache.$el.dataset.main_product);
    ctx.products = JSON.parse(ctx.cache.$el.dataset.products);
  },

  e_SelectFlavour(ctx, e) {
    let flavour = e.currentTarget.dataset.title;
    let selected = [...ctx.selected_flavors];

    if (selected.includes(flavour)) {
      selected = selected.filter(item => item !== flavour);
    }
    else {
      selected.push(flavour);
    }

    if (selected.length > this.maxItems) {
      selected.splice(0, 1);
    }

    ctx.$nextTick(() => {
      ctx.selected_flavors = [...selected];
    });
  },

  e_RemoveFlavour(ctx, itemIndex) {
    let selected = ctx.selected_flavors;
    selected.splice(itemIndex, 1);
    ctx.selected_flavors = [...selected];
  },

  u_CheckIfSelected(ctx, flavour) {
    return ctx.selected_flavors.includes(flavour);
  },

  u_SyncFlavorProducts(ctx) {
    ctx.selected_products = [...ctx.products.filter(product => ctx.selected_flavors.includes(product.title))];
    ctx.remaining_items = ctx.max_items - ctx.selected_products.length;
    ctx.flags.is_bundle_complete = ctx.remaining_items === 0;
  },

  parseHiddenSizes(str) {
    if (!str) return [];
    return str.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  },

  isSizeHidden(size, hiddenSizes) {
    if (!size || !hiddenSizes?.length) return false;
    return hiddenSizes.includes(size.trim().toLowerCase());
  },

  getFirstVisibleSizeInput($el, hiddenSizes) {
    let inputs = $el.querySelectorAll('[data-option-position="1"] input[type="radio"]');
    for (let input of inputs) {
      if (!this.isSizeHidden(input.value, hiddenSizes)) return input;
    }
    return null;
  },

  getFirstVisibleVariant(variants, hiddenSizes) {
    if (!variants?.length) return null;
    if (!hiddenSizes?.length) return variants[0];
    return variants.find(v => !this.isSizeHidden(v.option1, hiddenSizes)) || null;
  },

  ensureVisibleSizeSelected(ctx) {
    let hiddenSizes = ctx.hiddenSizes || [];
    let preselect = (window.theme?.preselect_pack_size || '').trim();
    let $checked = ctx.cache.$el.querySelector('[data-option-position="1"] input:checked');
    let $preselectInput = null;

    if (preselect) {
      let inputs = ctx.cache.$el.querySelectorAll('[data-option-position="1"] input[type="radio"]');
      for (let input of inputs) {
        if ((input.value || '').trim().toLowerCase() === preselect.toLowerCase()) {
          $preselectInput = input;
          break;
        }
      }
    }

    if ($preselectInput && !this.isSizeHidden($preselectInput.value, hiddenSizes)) {
      if (!$checked || this.isSizeHidden($checked.value, hiddenSizes) || $checked === $preselectInput) {
        $preselectInput.checked = true;
        let variant = ctx.u_GetSelectedVariant();
        if (variant) ctx.selected_variant = {...variant};
        return;
      }
    }

    if (!hiddenSizes.length) {
      let variant = ctx.u_GetSelectedVariant();
      if (variant) ctx.selected_variant = {...variant};
      return;
    }

    if ($checked && !this.isSizeHidden($checked.value, hiddenSizes)) {
      let variant = ctx.u_GetSelectedVariant();
      if (variant) ctx.selected_variant = {...variant};
      return;
    }

    let firstVisible = this.getFirstVisibleSizeInput(ctx.cache.$el, hiddenSizes);
    if (firstVisible) {
      firstVisible.checked = true;
      let variant = ctx.u_GetSelectedVariant();
      if (variant) ctx.selected_variant = {...variant};
    }
  },

  getDiscountedCents(cents, discountPercent) {
    if (!discountPercent || discountPercent <= 0) return cents;
    return Math.round(cents * (100 - discountPercent) / 100);
  },

  formatOnetimePrice(cents, discountPercent) {
    if (!discountPercent || discountPercent <= 0) return u_FormatMoney(cents);
    return `<s class="fullPrice">${u_FormatMoney(cents)}</s> ${u_FormatMoney(this.getDiscountedCents(cents, discountPercent))}`;
  },

  formatSubscriptionPrice(onetimeCents, subscriptionCents, discountPercent) {
    let sale = this.getDiscountedCents(subscriptionCents, discountPercent);
    if (Math.round(onetimeCents) === Math.round(sale)) return u_FormatMoney(sale);
    return `<s class="fullPrice">${u_FormatMoney(onetimeCents)}</s> ${u_FormatMoney(sale)}`;
  },

  // StayAI owns [data-stayai-onetime-price] text — keep compare-at in a sibling it won't wipe
  applyStayAiOtpPrice($priceEl, variantPrice, membershipPercentOff) {
    if (!$priceEl || variantPrice == null) return;

    let $wrap = $priceEl.closest('[data-sv-member-price-wrap]');
    let $compare = $wrap
      ? $wrap.querySelector('[data-sv-member-compare]')
      : ($priceEl.previousElementSibling?.hasAttribute?.('data-sv-member-compare')
          ? $priceEl.previousElementSibling
          : null);

    let saleText = membershipPercentOff > 0
      ? u_FormatMoney(variantPrice * (1 - membershipPercentOff / 100))
      : u_FormatMoney(variantPrice);
    let compareText = membershipPercentOff > 0 ? u_FormatMoney(variantPrice) : '';

    // Skip DOM writes when already correct — avoids thrashing StayAI / layout
    if (membershipPercentOff > 0) {
      if ($wrap && $compare && $compare.textContent === compareText && $priceEl.textContent === saleText) {
        $priceEl.classList.add('sv-member-priced');
        return;
      }
      if (!$wrap) {
        $wrap = document.createElement('span');
        $wrap.setAttribute('data-sv-member-price-wrap', '');
        $priceEl.parentNode.insertBefore($wrap, $priceEl);
        $wrap.appendChild($priceEl);
      }
      if (!$compare) {
        $compare = document.createElement('s');
        $compare.className = 'fullPrice';
        $compare.setAttribute('data-sv-member-compare', '');
        $wrap.insertBefore($compare, $priceEl);
      }
      if ($compare.textContent !== compareText) $compare.textContent = compareText;
      $priceEl.classList.add('sv-member-priced');
      if ($priceEl.textContent !== saleText) $priceEl.textContent = saleText;
    } else {
      if ($compare) $compare.remove();
      $priceEl.classList.remove('sv-member-priced');
      if ($priceEl.textContent !== saleText) $priceEl.textContent = saleText;
      if ($wrap) {
        $wrap.parentNode.insertBefore($priceEl, $wrap);
        $wrap.remove();
      }
    }
  },
};

document.addEventListener('alpine:init', () => {
  Alpine.data('SvPerCanPrices', () => ({
    texts: {},
    product: null,
    abortController: null,

    init() {
      this.seedFromDom();
      this.update();
      this.bind();
    },

    destroy() {
      this.abortController?.abort();
    },

    seedFromDom() {
      const seeded = {};
      this.$el.querySelectorAll('[data-sv-per-can]').forEach((node) => {
        const packCount = parseInt(node.getAttribute('data-sv-pack-count'), 10);
        const text = (node.textContent || '').trim();
        if (packCount && text) seeded[packCount] = text;
      });
      this.texts = seeded;
    },

    bind() {
      this.abortController = new AbortController();
      const opts = { signal: this.abortController.signal };
      const root = this.getRoot();
      const onUpdate = () => this.update();

      root.addEventListener('change', onUpdate, opts);
      root.addEventListener('input', onUpdate, opts);
      root.addEventListener('click', (event) => {
        if (
          event.target?.closest?.('.stayai-subscriptions') ||
          event.target?.closest?.('.h-frequency-picker')
        ) {
          requestAnimationFrame(onUpdate);
        }
      }, opts);
      document.addEventListener('theme:variant:change', (event) => {
        if (root.contains(event.target) || event.target?.contains?.(this.$el)) onUpdate();
      }, opts);
      document.addEventListener('shopify:section:load', (event) => {
        if (event.target?.contains?.(this.$el)) onUpdate();
      }, opts);

      u_OnElementLoad('.stayai-subscriptions', ($el) => {
        if (!$el || !root.contains($el)) return;
        onUpdate();
      });
    },

    getRoot() {
      return (
        this.$el.closest('.h-build-mixed-match-case') ||
        this.$el.closest('build-mixed-case') ||
        this.$el.closest('[data-quick-add-modal]') ||
        this.$el.closest('[data-section-type="product"]') ||
        this.$el.closest('product-component') ||
        this.$el.closest('[data-product]') ||
        document
      );
    },

    getProduct() {
      if (this.product) return this.product;
      const root = this.getRoot();
      const el = root.querySelector('[data-product-json]');
      if (el?.textContent) {
        try {
          this.product = JSON.parse(el.textContent);
          return this.product;
        } catch (e) {
          this.product = null;
        }
      }

      const mixed = this.$el.closest('[data-main_product]') || root.querySelector('[data-main_product]');
      if (mixed?.dataset?.main_product) {
        try {
          this.product = JSON.parse(mixed.dataset.main_product);
        } catch (e) {
          this.product = null;
        }
      }
      return this.product;
    },

    getSellingPlanId() {
      const root = this.getRoot();
      const purchaseType = root.querySelector('[name^="frequency-type-"]:checked')?.value;
      if (purchaseType === 'onetime') return null;

      const checked = root.querySelector('[name="selling_plan"]:checked');
      if (checked && checked.value && !checked.disabled) return checked.value;

      for (const input of root.querySelectorAll('[name="selling_plan"]')) {
        if (input.type === 'radio' || input.disabled) continue;
        if (input.value) return input.value;
      }

      if (purchaseType === 'subscription') return null;

      const stayai = root.querySelector('[name="stayai_selling_plan"]');
      if (stayai?.value) return stayai.value;

      return null;
    },

    getSelectedOptions() {
      const values = [];
      this.getRoot().querySelectorAll('[data-option-position]').forEach((wrapper) => {
        const pos = parseInt(wrapper.getAttribute('data-option-position'), 10);
        if (!pos) return;

        let value = null;
        const checked = wrapper.querySelector('[data-single-option-selector]:checked');
        if (checked) {
          value = checked.value;
        } else {
          const input = wrapper.querySelector('[data-single-option-selector]:not([type="radio"])');
          if (input) value = input.value;
        }
        values[pos - 1] = value;
      });
      return values;
    },

    findVariantForSize(selectedOptions, sizePosition, sizeValue) {
      const product = this.getProduct();
      if (!product?.variants?.length || !sizePosition || !sizeValue) return null;

      const options = selectedOptions.slice();
      options[sizePosition - 1] = sizeValue;

      return (
        product.variants.find((variant) =>
          options.every((value, index) => {
            if (!value) return true;
            return variant[`option${index + 1}`] === value;
          })
        ) ||
        product.variants.find((variant) => variant[`option${sizePosition}`] === sizeValue) ||
        null
      );
    },

    getEffectivePrice(variant, planId) {
      if (!variant || variant.price == null) return null;

      if (planId && variant.selling_plan_allocations?.length) {
        const allocation = variant.selling_plan_allocations.find(
          (item) => String(item.selling_plan_id) === String(planId)
        );
        if (allocation?.price != null) return allocation.price;
        if (allocation?.per_delivery_price != null) return allocation.per_delivery_price;
      }

      return variant.price;
    },

    textFor(packCount) {
      return this.texts[packCount] || '';
    },

    update() {
      const product = this.getProduct();
      if (!product || !window.theme?.formatMoney) return;

      const selectedOptions = this.getSelectedOptions();
      const planId = this.getSellingPlanId();
      const next = {};

      this.$el.querySelectorAll('[data-sv-per-can]').forEach((node) => {
        const packCount = parseInt(node.getAttribute('data-sv-pack-count'), 10);
        const sizeValue = node.getAttribute('data-sv-size-value');
        const sizePosition = parseInt(node.getAttribute('data-sv-option-position'), 10);
        if (!packCount || !sizeValue || !sizePosition) return;

        const variant = this.findVariantForSize(selectedOptions, sizePosition, sizeValue);
        const price = this.getEffectivePrice(variant, planId);
        if (price == null || !Number.isFinite(price)) return;

        next[packCount] = `${u_FormatMoney(Math.floor(price / packCount))} / can`;
      });

      if (Object.keys(next).length) {
        this.texts = next;
      }
    },
  }));

  Alpine.data('BuildMixedCase', () => ({
    cache: {},
    main_product: null,
    products: [],
    selected_flavors: [],
    selected_products: [],
    selected_variant: null,
    max_items: 2,
    remaining_items: 2,
    flags: {
      is_bundle_complete: false,
      show_selected_packs: false
    },
    timestamp: `${new Date().getMinutes()}:${new Date().getSeconds()}`,
    isTapcart: false,
    init() {
      this.InitWatchers();
      this.InitSelf();
      mixedCaseShared.initTapcart(this);
    },
    InitSelf() {
      mixedCaseShared.initCache(this);
      mixedCaseShared.ensureVisibleSizeSelected(this);
      if (!this.selected_variant && this.main_product?.variants?.[0]) {
        this.selected_variant = {...this.main_product.variants[0]};
      }
      this.u_UpdateStayAIPrices();

      this.cache.$el.addEventListener('change', () => {
        this.u_UpdateStayAIPrices();
      });

      // StayAI mounts async — re-apply membership OTP when widget appears
      u_OnElementLoad('.stayai-subscriptions', ($el) => {
        if (!$el || !this.cache.$el.contains($el)) return;
        if (!this.selected_variant && this.main_product?.variants?.[0]) {
          this.selected_variant = {...this.main_product.variants[0]};
        }
        this.u_UpdateStayAIPrices();
      });
    },
    InitWatchers() {
      this.$watch('selected_flavors', () => {
        mixedCaseShared.u_SyncFlavorProducts(this);

        this.$nextTick(() => {
          let selected_variant = this.u_GetSelectedVariant();
          if (this.selected_variant && this.selected_variant.id == selected_variant.id) { 
            // If the selected variant is the same, do not update
          }
          else {
            this.selected_variant = {...selected_variant};
          }
        });
      });

      // pack selection from product
      this.$el.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-position="1"] input')) {
          this.selected_variant = {...this.u_GetSelectedVariant()};
        }
      });

      this.$watch('selected_variant', () => {
        if (!this.selected_variant || !this.selected_variant.id) return;
        this.cache.$el.querySelectorAll('[name="id"]').forEach(input => {
          input.value = this.selected_variant ? this.selected_variant.id : this.main_product.variants[0].id;
        });

        this.u_UpdateStayAIPrices();
      });
    },
    e_SelectFlavour(e) {
      mixedCaseShared.e_SelectFlavour(this, e);
    },

    e_RemoveFlavour(itemIndex) {
      mixedCaseShared.e_RemoveFlavour(this, itemIndex);
    },

    u_GetSelectedVariant() {
      let selected_flavors = [...this.selected_flavors];
      let $checked = this.cache.$el.querySelector('[data-option-position="1"] input:checked');
      let selected_variant = $checked
        ? this.main_product.variants.find(v => {
            return v.option1 == $checked.value &&
              (v.option2 == selected_flavors.join(' x ') || v.option2 == selected_flavors.reverse().join(' x '));
          })
        : null;
      return selected_variant || this.main_product.variants[0];
    },

    u_CheckIfSelected(flavour) {
      return mixedCaseShared.u_CheckIfSelected(this, flavour);
    },

    u_UpdateStayAIPrices() {
      if (!this.selected_variant) return;

      let membership_discount = window.theme?.membership_discount;
      let membership_percent_off = 0;
      if (membership_discount && membership_discount.enabled) {
        membership_percent_off = membership_discount.percent_off || (membership_discount.is_tier_standard ? membership_discount.tier_standard_percent_off : 0);
      }

      let variant_price = this.selected_variant.price;
      let subscription_percent = 0.15;
      let subscription_price = variant_price * (1 - subscription_percent);

      let price_selectors = ['[data-stayai-onetime-price]'];
      price_selectors.forEach(selector => {
        let $price_element = this.cache.$el.querySelector(selector);
        if (!$price_element) return;
        mixedCaseShared.applyStayAiOtpPrice($price_element, variant_price, membership_percent_off);
      });

      this.cache.$el.querySelectorAll('[data-stayai-subscription-price]').forEach($price_element => {
        $price_element.innerHTML = mixedCaseShared.formatSubscriptionPrice(variant_price, subscription_price, 0);
      });

      let save_label = '15%';
      this.cache.$el.querySelectorAll('*').forEach(($node) => {
        if ($node.children.length) return;
        let text = $node.textContent || '';
        if (!/Save\s+\d+%/i.test(text)) return;
        $node.textContent = text.replace(/Save\s+\d+%/i, `Save ${save_label}`);
      });
    },

    u_GetSelectedFrequency() {
      let $frequency_select = this.cache.$el.querySelector('[name="stayai_selling_plan"]');
      if (!this.selected_variant) return null;
      if (!$frequency_select) return null;
      let selected_frequency = $frequency_select.value || this.selected_variant.selling_plan_allocations?.[0]?.selling_plan_id;
      return selected_frequency;
    },

    e_AddTapCart(e) {
      e.preventDefault();
      e.stopPropagation();
      let $form = e.currentTarget.closest('form');
      let form_data = new FormData($form);
      let form_obj = {};
      form_data.forEach((value, key) => {
        form_obj[key] = value;
      });
      // console.log('Add to cart intercepted for Tapcart:', JSON.stringify(form_obj));

      let item_to_add = {
        id: form_obj.id,
        quantity: parseInt(form_obj.quantity) || 1,
        properties: {}
      };
      if (form_obj.selling_plan !== '') {
        item_to_add.selling_plan = form_obj.selling_plan;
      }
      let add_to_cart_obj = {
        items: [item_to_add],
      };

      console.log('Adding to cart via Tapcart:\n' + JSON.stringify(add_to_cart_obj));

      // Add the item to Tapcart
      let lineItem = {
        quantity: item_to_add.quantity,
        variantId: item_to_add.id,
        sellingPlanId: item_to_add.selling_plan || null,
      }      
      Tapcart.actions.addToCart({
        lineItems: [lineItem],
      })      
    }
  }));

  Alpine.data('BuildMixedMatchCase', () => ({
    cache: {},
    main_product: null,
    products: [],
    selected_flavors: [],
    selected_products: [],
    selected_variant: null,
    max_items: 2,
    remaining_items: 2,
    bundleId: null,
    purchase_type: 'onetime',
    hiddenSizes: [],
    discountPercent: 0,
    flags: {
      is_bundle_complete: false,
      show_selected_packs: false
    },
    timestamp: `${new Date().getMinutes()}:${new Date().getSeconds()}`,
    isTapcart: false,
    init() {
      this.bundleId = `bundle-${this.timestamp}-${Date.now()}`;
      this.InitWatchers();
      this.InitSelf();
      mixedCaseShared.initTapcart(this);
    },
    InitSelf() {
      mixedCaseShared.initCache(this);
      this.hiddenSizes = mixedCaseShared.parseHiddenSizes(this.cache.$el.dataset.hiddenSizes);
      this.discountPercent = Number(this.cache.$el.dataset.discountPercent) || 0;

      // Fall back to first visible size when the default selection is hidden
      mixedCaseShared.ensureVisibleSizeSelected(this);
      this.u_UpdateFrequencyPrices();

      this.cache.$el.addEventListener('change', () => {
        this.u_UpdateFrequencyPrices();
      });
    },
    InitWatchers() {
      this.$watch('selected_flavors', () => {
        mixedCaseShared.u_SyncFlavorProducts(this);

        this.$nextTick(() => {
          let selected_variant = this.u_GetSelectedVariant();
          if (selected_variant && (!this.selected_variant || this.selected_variant.id !== selected_variant.id)) {
            this.selected_variant = {...selected_variant};
          }
        });
      });

      this.$el.addEventListener('change', (e) => {
        if (e.target.closest('[data-option-position="1"]') && e.target.matches('input[type="radio"]')) {
          let selected_variant = this.u_GetSelectedVariant();
          if (selected_variant) {
            this.selected_variant = {...selected_variant};
          }
        }
      });

      this.$watch('selected_variant', () => {
        if (!this.selected_variant?.id) return;
        this.u_UpdateFrequencyPrices();
      });
    },
    e_SelectFlavour(e) {
      mixedCaseShared.e_SelectFlavour(this, e);
    },
    e_RemoveFlavour(itemIndex) {
      mixedCaseShared.e_RemoveFlavour(this, itemIndex);
    },
    u_CheckIfSelected(flavour) {
      return mixedCaseShared.u_CheckIfSelected(this, flavour);
    },
    u_GetSelectedSize() {
      let $input = this.cache.$el.querySelector('[data-option-position="1"] input:checked');
      if ($input?.value) return $input.value;

      let hiddenSizes = this.hiddenSizes || [];
      if (hiddenSizes.length) {
        let firstVisible = mixedCaseShared.getFirstVisibleSizeInput(this.cache.$el, hiddenSizes);
        return firstVisible?.value || null;
      }

      let $first = this.cache.$el.querySelector('[data-option-position="1"] input[type="radio"]');
      return $first?.value || null;
    },
    u_GetSelectedVariant() {
      let size = this.u_GetSelectedSize();
      if (size) {
        let variant = this.main_product.variants.find(v => v.option1 === size);
        if (variant) return variant;
      }
      return mixedCaseShared.getFirstVisibleVariant(this.main_product.variants, this.hiddenSizes);
    },
    u_GetProductVariant(product) {
      if (!product?.variants?.length) return null;
      let size = this.u_GetSelectedSize();
      if (size) {
        let variant = product.variants.find(v => v.option1 === size || v.title.includes(size));
        if (variant) return variant;
      }
      return mixedCaseShared.getFirstVisibleVariant(product.variants, this.hiddenSizes) || product.variants[0];
    },
    u_GetPurchaseType() {
      return this.purchase_type || 'onetime';
    },
    u_GetFrequencySelection() {
      let $select = this.cache.$el.querySelector('[name="selling_plan"]');
      if (!$select) return {id: null, name: null};
      let option = $select.options[$select.selectedIndex];
      return {
        id: $select.value || null,
        name: option?.textContent?.trim() || null,
      };
    },
    u_GetSellingPlan() {
      if (this.u_GetPurchaseType() !== 'subscription') return null;
      return this.u_GetFrequencySelection().id;
    },
    u_GetProductSellingPlan(product, variant) {
      if (this.u_GetPurchaseType() !== 'subscription') return null;

      let {id, name} = this.u_GetFrequencySelection();
      let allocations = variant?.selling_plan_allocations || [];

      if (id && allocations.some(a => String(a.selling_plan_id) === String(id))) {
        return id;
      }

      if (name && product.selling_plan_groups?.length) {
        for (let group of product.selling_plan_groups) {
          let plan = group.selling_plans?.find(p => p.name === name);
          if (plan && allocations.some(a => String(a.selling_plan_id) === String(plan.id))) {
            return String(plan.id);
          }
        }
      }

      return allocations[0]?.selling_plan_id ? String(allocations[0].selling_plan_id) : id;
    },
    u_UpdateFrequencyPrices() {
      if (!this.selected_variant) return;

      let membership_discount = window.theme?.membership_discount;
      let membership_percent_off = 0;
      if (membership_discount && membership_discount.enabled) {
        membership_percent_off = membership_discount.percent_off || (membership_discount.is_tier_standard ? membership_discount.tier_standard_percent_off : 0);
      }

      let onetimeCents = this.selected_variant.price;
      let subscription_percent = 15;
      let subscriptionCents = Math.round(onetimeCents * (100 - subscription_percent) / 100);

      let $onetime = this.cache.$el.querySelector('[data-mixed-onetime-price]');
      let $subscription = this.cache.$el.querySelector('[data-mixed-subscription-price]');

      if (membership_percent_off > 0) {
        if ($onetime) {
          $onetime.classList.add('sv-member-priced');
          $onetime.innerHTML = mixedCaseShared.formatOnetimePrice(onetimeCents, membership_percent_off);
        }
      } else {
        if ($onetime) {
          $onetime.classList.remove('sv-member-priced');
          $onetime.innerHTML = mixedCaseShared.formatOnetimePrice(onetimeCents, this.discountPercent);
        }
      }

      if ($subscription) {
        $subscription.innerHTML = mixedCaseShared.formatSubscriptionPrice(onetimeCents, subscriptionCents, 0);
      }

      this.cache.$el.querySelectorAll('.h-frequency-label').forEach(($label) => {
        let text = $label.textContent || '';
        if (!/Autoship.*Save\s+\d+%/i.test(text)) return;
        $label.textContent = text.replace(/Autoship\s*&\s*Save\s+\d+%/i, `Autoship & Save ${subscription_percent}%`);
      });
    },
    u_BuildCartItem(product) {
      let variant = this.u_GetProductVariant(product);
      if (!variant) return null;

      let purchase_type = this.u_GetPurchaseType();
      let item = {
        id: variant.id,
        quantity: 1,
        properties: {
          _mix_match_id: this.bundleId,
          _product_id: product.id,
          _purchase_type: purchase_type,
        },
      };

      if (purchase_type === 'subscription') {
        let {name} = this.u_GetFrequencySelection();
        let selling_plan = this.u_GetProductSellingPlan(product, variant);

        if (name) {
          item.properties._frequency = name;
        }
        if (selling_plan) {
          item.selling_plan = selling_plan;
        }
      }

      return item;
    },
    u_BuildCartItems() {
      return this.selected_products
        .map(product => this.u_BuildCartItem(product))
        .filter(Boolean);
    },
    async e_AddToCart(e, buttonEl) {
      e?.preventDefault?.();
      if (!this.flags.is_bundle_complete) return;

      let button = buttonEl || e?.currentTarget || e?.target?.closest?.('button');
      let items = this.u_BuildCartItems();
      if (!items.length) return;

      if (button) {
        button.classList.add('loading');
        button.disabled = true;
      }

      let res = await u_AddItemsToCart(items);
      let data = await res.json();

      if (button) {
        button.classList.remove('loading');
        button.disabled = false;
      }

      if (data.status) {
        console.error('Error adding to cart:', data);
        return;
      }

      // Refresh drawer from live cart — do not emit theme:product:add (that path expects a form add).
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    },
    e_AddTapCart(e) {
      e.preventDefault();
      e.stopPropagation();

      let items = this.u_BuildCartItems();
      if (!items.length) return;

      Tapcart.actions.addToCart({
        lineItems: items.map(item => ({
          quantity: item.quantity,
          variantId: item.id,
          sellingPlanId: item.selling_plan || null,
          attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
            key,
            value: String(value),
          })),
        })),
      });
    }
  }));

  Alpine.data('BuildBundlePacks', () => ({
    cache: {},
    pack_sizes: [],
    flavor_products: [],
    selected_flavors: [],
    selected_size: '',
    bundle_products: [],
    max_items: 2,
    remaining_items: 2,
    flags: {
      is_bundle_complete: false,
      show_selected_packs: false
    },
    get SelectedFlavorProducts() {
      return this.flavor_products.filter(product => this.selected_flavors.includes(product.title));
    },
    get SelectedBundleProduct() {
      // take first word of each flavor
      let flavors = this.selected_flavors.map(flavor => flavor.split(' ')[0]);
      if (flavors.length < this.max_items) return null;
      // match both flavors in the product title
      let matching_product = this.bundle_products.find(product => flavors.every(flavor => product.title.includes(flavor)));
      return matching_product || null;
    },
    timestamp: `${new Date().getMinutes()}:${new Date().getSeconds()}`,
    isTapcart: false,
    init() {
      this.InitWatchers();
      this.InitSelf();

      // Shopify.shop is only for webstores, so we can use its absence to detect Tapcart
      if (!Shopify.shop) {
        window.addEventListener('webbridge-ready', (e) => {
          console.log('Webbridge is ready - Tapcart detected', e);
          this.isTapcart = true;
        });
      }
    },
    InitSelf() {
      this.cache.$el = this.$el;
      this.flavor_products = JSON.parse(this.cache.$el.dataset.flavor_products);
      this.bundle_products = JSON.parse(this.cache.$el.dataset.bundle_products);

      let pack_sizes = ['6 - Pack', '12 - Pack', '24 - Pack'];
      pack_sizes = pack_sizes.filter(size => this.bundle_products.some(product => product.title.includes(size)));
      this.pack_sizes = pack_sizes;
      this.selected_size = pack_sizes[0];
    },
    InitWatchers() {
      this.$watch('selected_flavors', () => {
        this.flags.is_bundle_complete = this.SelectedBundleProduct !== null;
      });
    },
    e_SelectFlavour(e) {
      // console.log(e.currentTarget);
      let flavour = e.currentTarget.dataset.title;
      let selected = [...this.selected_flavors];

      if (selected.includes(flavour)) {
        selected = selected.filter(item => item !== flavour);
      }
      else {
        selected.push(flavour);
      }

      if (selected.length > 2) {
        selected.splice(0, 1);
      }

      this.$nextTick(() => {
        this.selected_flavors = [...selected];
      });
    },

    e_RemoveFlavour(itemIndex) {
      let selected = this.selected_flavors;
      selected.splice(itemIndex, 1);
      this.selected_flavors = [...selected];
    },

    u_CheckIfSelected(flavour) {
      return this.selected_flavors.includes(flavour);
    },

    e_AddTapCart(e) {
      e.preventDefault();
      e.stopPropagation();
      let $form = e.currentTarget.closest('form');
      let form_data = new FormData($form);
      let form_obj = {};
      form_data.forEach((value, key) => {
        form_obj[key] = value;
      });
      // console.log('Add to cart intercepted for Tapcart:', JSON.stringify(form_obj));

      let item_to_add = {
        id: form_obj.id,
        quantity: parseInt(form_obj.quantity) || 1,
        properties: {}
      };
      if (form_obj.selling_plan !== '') {
        item_to_add.selling_plan = form_obj.selling_plan;
      }
      let add_to_cart_obj = {
        items: [item_to_add],
      };

      console.log('Adding to cart via Tapcart:\n' + JSON.stringify(add_to_cart_obj));

      // Add the item to Tapcart
      let lineItem = {
        quantity: item_to_add.quantity,
        variantId: item_to_add.id,
        sellingPlanId: item_to_add.selling_plan || null,
      }      
      Tapcart.actions.addToCart({
        lineItems: [lineItem],
      })      
    },

    async e_AddBundleToCart(e) {
      let variant_id = null;
      if (this.pack_sizes.length == 1) {
        variant_id = this.SelectedBundleProduct.variants[0].id;
      }
      else {
        variant_id = this.SelectedBundleProduct.variants.find(variant => variant.title.includes(this.selected_size)).id;
      }

      if (!variant_id) {
        console.error('No variant found for size:', this.selected_size);
        return;
      }

      let add_res = await u_AddItemsToCart([{ id: variant_id, quantity: 1 }]).then(res => res.json());
      if (add_res.status) {
        console.log('Cart:', add_res);
      } 
      else {
        console.error('Error adding to cart:', add_res);
      }
    },

    formatMoney(price) {
      return u_FormatMoney(price);
    }
  }));

  // Mixed case builder: remove the subscription widget that loads automatically
  u_OnElementLoad('.h-build-mixed .rtxn-block', ($el) => {
    if (!$el) return;
    $el.remove();
  });

  // Move subscription offers to the subscription widget
  u_OnElementLoad('.stayai-subscriptions', ($el) => {
    // console.log($el);
    if (!$el) return;
    let $product = $el.closest('.form__wrapper') || $el.closest('product-form');
    if (!$product) return;

    let $subscription_details = $el.querySelector('.stayai-subscription-details-container');
    if (!$subscription_details) return;

    let $subscription_offers = $product.querySelector('.h-subscription-offers')
    if (!$subscription_offers) return;

    $subscription_details.innerHTML = ''; // Clear existing content
    $subscription_details.insertAdjacentElement('beforeend', $subscription_offers);
    $subscription_offers.classList.add('is-visible');

    // SV- Membership: OTP uses membership %; autoship always 15% (display only)
    UpdateStayAIPrices = () => {
      let membership_discount = window.theme?.membership_discount;
      let membership_percent_off = 0;
      if (membership_discount && membership_discount.enabled) {
        membership_percent_off = membership_discount.percent_off || (membership_discount.is_tier_standard ? membership_discount.tier_standard_percent_off : 0);
      }

      if (window.current_variant == null) return;

      let $price_onetime = $product.querySelector('[data-stayai-onetime-price]');
      if ($price_onetime) {
        let variant_price = window.current_variant.price;
        mixedCaseShared.applyStayAiOtpPrice($price_onetime, variant_price, membership_percent_off);
      }

      let $price_subscription = $product.querySelector('[data-stayai-subscription-price]');
      if ($price_subscription) {
        let subscription_percent = 0.15;
        let variant_price = window.current_variant.price;
        let subscription_price = variant_price * (1 - subscription_percent);
        $price_subscription.innerHTML = mixedCaseShared.formatSubscriptionPrice(variant_price, subscription_price, 0);
      }

      let save_label = '15%';
      $el.querySelectorAll('*').forEach(($node) => {
        if ($node.children.length) return;
        let text = $node.textContent || '';
        if (!/Save\s+\d+%/i.test(text)) return;
        $node.textContent = text.replace(/Save\s+\d+%/i, `Save ${save_label}`);
      });

      $el.querySelectorAll('.subscription-savings').forEach(($savings) => {
        let text = $savings.textContent || '';
        if (/\d+%/.test(text)) {
          $savings.textContent = text.replace(/\d+%/g, save_label);
        } else {
          $savings.textContent = save_label;
        }
      });
    }
    UpdateStayAIPrices();
    setTimeout(UpdateStayAIPrices, 100);
    setTimeout(UpdateStayAIPrices, 500);

    // on variant change, update the prices in the subscription widget
    document.addEventListener('theme:variant:change', (e) => {
      setTimeout(UpdateStayAIPrices, 0); // delay to ensure variant change has fully propagated
    });

    // on frequency change, update the subscription price
    $el.addEventListener('change', (e) => {
      setTimeout(UpdateStayAIPrices, 0); // delay to ensure variant change has fully propagated
    });
  });
});

UnlockThemeScroll = () => {
  document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
}

// Unlock scroll when cart drawer or rebuy quick view / smart cart opens, in case the theme has locked scroll and forgot to unlock it
document.addEventListener('theme:cart-drawer:open', (event) => {
  setTimeout(UnlockThemeScroll, 500); // delay to ensure it runs after any potential scroll lock from theme
});
document.addEventListener('rebuy:quickview.show', (event) => {
  setTimeout(UnlockThemeScroll, 500); // delay to ensure it runs after any potential scroll lock from rebuy
});

document.addEventListener('rebuy:smartcart.show', (event) => {
  setTimeout(UnlockThemeScroll, 500); // delay to ensure it runs after any potential scroll lock from rebuy
});
document.addEventListener('rebuy:smartcart.hide', (event) => {
  // remove scroll lock when rebuy smart cart is closed
  setTimeout(UnlockThemeScroll, 500); // delay to ensure it runs after any potential scroll lock from rebuy 
});